import { CanActivate, Router } from '@angular/router';
import { ExternalSourceProviderEnum } from '@gp-angular/shared/schema';
import { ProviderService } from '@gp-angular/service/provider';
import { Injectable } from '@angular/core';
import { PAGE } from '@gp-angular/shared/schema';
import { map, Observable, take } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class IsOraInitializedProviderGuard implements CanActivate {

	public readonly PAGE = PAGE;

	constructor(
		private _providerService: ProviderService,
		private _router: Router
	) {
	}

	canActivate(): Observable<boolean> {
		return this._providerService.readProvider$().pipe(
			take(1),
			map(provider => {
				const isOra = provider?.externalSource === ExternalSourceProviderEnum.ORA;
				const isInitialized = provider?.oraInitialized === true;
				if (!isOra || (isOra && isInitialized)) {
					return true;
				}
				this._router.navigate([PAGE.UPDATE_PROVIDER_DATA_VIA_ORA.path]).then(() => {});
				return false;
			})
		);
	}
}
